<template>
  <div>
    <list
      row-key="UserId"
      ref="list"
      unit="综合评价指标"
      :expand-all-row="true"
      :page="false"
      :query-params="isSearch?searchParams:params"
      :show-checkbox="false"
      :show-query="showQuery"
      :get-data-func="getDataFunc"
      :show-reset="false"
      table-title="信息列表"
      :custom-search="customSearch"
      @count="count"
      null-tip="当前考试暂无数据"
      @search="search"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="query">
        <el-form-item label="入学年份" :style="isMB?'':'margin-left:18px;'">
          <el-select v-model="data.SchoolYear" size="mini" @change="reset" clearable>
            <el-option v-for="item in yearList" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前考试名称" class="listLabel">
          <el-input v-model="data.ThisLvSn" size="mini" class="longInp" readonly @focus="onExamDialog(false)" placeholder="请选择考试"/>
        </el-form-item>
        <!-- <el-form-item label="入口考试名称" class="listLabel">
          <el-input v-model="data.EntryLvSn" size="mini" readonly @focus="onExamDialog(true)" class="entryInp" placeholder="请选择考试"/>
        </el-form-item> -->
        <div class="entryBox">
          <span class="entryTitle">入口考试名称</span>
          <el-input class="entrySelect" v-model="data.EntryLvSn" size="mini" :title="data.EntryLvSn" readonly @focus="onExamDialog(true)" placeholder="请选择考试"/>
        </div> 
      </template>
      <template slot="table">
        <slot name="column">
          <el-table-column prop="ClassName" label="班级" width="100"/>
          <el-table-column prop="" label="语文" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.YwTeacherName?'tname':''" @click="toDetails(row,'ThisYwTeacherId','YwTeacherName')">{{row.YwTeacherName||''}}</el-link>
              <span v-if="row.YwTeacherName">{{row.YwIndexLv?(row.YwIndexLv+'级 '):' '}}</span>
              <span v-if="row.YwTeacherName">{{row.YwIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="数学" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.SxTeacherName?'tname':''" @click="toDetails(row,'ThisSxTeacherId','SxTeacherName')">{{row.SxTeacherName||''}}</el-link>
              <span v-if="row.SxTeacherName">{{row.SxIndexLv?(row.SxIndexLv+'级 '):' '}}</span>
              <span v-if="row.SxTeacherName">{{row.SxIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="英语" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.YyTeacherName?'tname':''" @click="toDetails(row,'ThisYyTeacherId','YyTeacherName')">{{row.YyTeacherName||''}}</el-link>
              <span v-if="row.YyTeacherName">{{row.YyIndexLv?(row.YyIndexLv+'级 '):' '}}</span>
              <span v-if="row.YyTeacherName">{{row.YyIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="物理" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.WlTeacherName?'tname':''" @click="toDetails(row,'ThisWlTeacherId','WlTeacherName')">{{row.WlTeacherName||''}}</el-link>
              <span v-if="row.WlTeacherName">{{row.WlIndexLv?(row.WlIndexLv+'级 '):' '}}</span>
              <span v-if="row.WlTeacherName">{{row.WlIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="化学" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.HxTeacherName?'tname':''" @click="toDetails(row,'ThisHxTeacherId','HxTeacherName')">{{row.HxTeacherName||''}}</el-link>
              <span v-if="row.HxTeacherName">{{row.HxIndexLv?(row.HxIndexLv+'级 '):' '}}</span>
              <span v-if="row.HxTeacherName">{{row.HxIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="生物" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.SwTeacherName?'tname':''" @click="toDetails(row,'ThisSwTeacherId','SwTeacherName')">{{row.SwTeacherName||''}}</el-link>
              <span v-if="row.SwTeacherName">{{row.SwIndexLv?(row.SwIndexLv+'级 '):' '}}</span>
              <span v-if="row.SwTeacherName">{{row.SwIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="历史" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.LsTeacherName?'tname':''" @click="toDetails(row,'ThisLsTeacherId','LsTeacherName')">{{row.LsTeacherName||''}}</el-link>
              <span v-if="row.LsTeacherName">{{row.LsIndexLv?(row.LsIndexLv+'级 '):' '}}</span>
              <span v-if="row.LsTeacherName">{{row.LsIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="政治" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.ZzTeacherName?'tname':''" @click="toDetails(row,'ThisZzTeacherId','ZzTeacherName')">{{row.ZzTeacherName||''}}</el-link>
              <span v-if="row.ZzTeacherName">{{row.ZzIndexLv?(row.ZzIndexLv+'级 '):' '}}</span>
              <span v-if="row.ZzTeacherName">{{row.ZzIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="地理" min-width="110">
            <template slot-scope="{row}">
              <el-link :class="row.DlTeacherName?'tname':''" @click="toDetails(row,'ThisDlTeacherId','DlTeacherName')">{{row.DlTeacherName||''}}</el-link>
              <span v-if="row.DlTeacherName">{{row.DlIndexLv?(row.DlIndexLv+'级 '):' '}}</span>
              <span v-if="row.DlTeacherName">{{row.DlIndexScore + ' 分'}}</span>
            </template>
          </el-table-column>
        </slot>
      </template>
    </list>
    <exam-dialog ref="examDialog" in-dialog selectable :multiple="false" @select="setThis"></exam-dialog>
    <exam-dialog2 ref="examDialog2" in-dialog selectable :multiple="true" :select-exam="params.Entries" @select-multiple="setEntry"></exam-dialog2>
    <entry-dialog ref="entryDialog" @confirm="confirm"></entry-dialog>
    <search-dialog ref="searchDialog" @confirm="confirm2"></search-dialog>
    <details-dialog ref="detailsDialog" in-dialog></details-dialog>
  </div>
</template>
<script>
import listMixin from "@/mixins/list";
import list from "@/components/common/list";
import examDialog from "@/components/achieve/exam/listDialog";
import examDialog2 from "@/components/achieve/exam/listDialog";
import entryDialog from "./entryDialog";
import searchDialog from "./searchDialog";
import detailsDialog from "./detailsDialog";

export default {
  mixins: [listMixin],
  components: { 
    list,
    examDialog,
    examDialog2,
    entryDialog,
    searchDialog,
    detailsDialog
  },
  data() {
    return {
      api: require("@/api/analyse/analyse").default,
      examApi: require("@/api/achieve/exam").default,
      AnalyseId: null,
      params: {
        Entries: [],
        ThisExamId: null,
        AnalyseType: 3
      },
      data: {
        ThisLvSn: null,
        SchoolYear: "",
        EntryLvSn: "",
      },
      EntryLvSn: "",
      Entries: [],
      yearList: [],
      TermId: null,
      tbl: [],
      isSearch: false,
      searchParams: {},
      customSearch: [
        { bn: "统计", fn: 'count' },
        { bn: "查询", fn: 'search' },
      ]
    };
  },
  beforeMount() {
    this.examApi.getYear().then(res => {
      for (let i = res.Data.length-1; i > -1; i--) {
        this.yearList.push(res.Data[i])
      }
    })
  },
  methods: {
    getDataFunc() {
      return new Promise((resolve, reject) => {
        if(this.isSearch) {
          this.api.filterAnalyse(this.searchParams).then(res => {
            this.tbl = res.Data.Classes||[];
            console.log(res.Data.Classes)
            resolve({ Data: res.Data.Classes||[] });
          })
        } else {
          var params = this.$commonJs.obj.removeNullKey(this.params);
          this.api.getAnalyse(params).then(res => {
            if(res.Code == 0) {
              this.tbl = res.Data.Classes||[];
              this.AnalyseId = res.Data.AnalyseId;
              this.$emit("listdata",{
                AnalyseId: this.AnalyseId,
                params: this.params,
                data: this.data,
                EntryLvSn: this.EntryLvSn,
                Entries: this.Entries,
                TermId: this.TermId
              })
              resolve({ Data: res.Data.Classes||[] });
            } else {
              this.$message.error(res.Msg);
            }
          });
        }
      });
    },
    onExamDialog(type) {
      if(!this.data.SchoolYear) {
        this.$message.error("请先选择入学年份")
        return
      }
      if(type) {
        this.$refs.examDialog2.open().then((that) => {
          that.getData({ SchoolYear: this.data.SchoolYear, ExamType: 0 }).then(() => {
            that.setSelected();
          })
        });
      } else {
        this.$refs.examDialog.open().then((that) => {
          that.getData({ SchoolYear: this.data.SchoolYear, ExamType: 0 });
        });
      }
    },
    setThis(exam) {
      this.TermId = exam.TermId;
      this.params.ThisExamId = exam.ExamId;
      this.data.ThisLvSn = exam.ExamCode;
    },
    setEntry(exam) {
      this.Entries = [];
      this.EntryLvSn = "";
      if(exam.length==0) {
        return
      }
      exam.forEach((e,index) => {
        this.Entries.push({
          EntryExamId: e.ExamId,
          EntryRatio: 0,
        })
        this.EntryLvSn += e.ExamCode;
        if(exam[index+1]) {
          this.EntryLvSn += '，';
        }
      });
      this.openDialog(exam.length)
    },
    openDialog(num) {
      if(num == 1) {
        this.confirm([{ ExamRatio: 100 }]);
      } else {
        this.$refs.entryDialog.open();
        this.$refs.entryDialog.setData(num);
      }
    },
    count() {
      if(!this.data.ThisLvSn) {
        this.$message.error("请先选择考试")
        return
      }
      if(this.Entries.length==0) {
        this.$message.error("请先选择入口考试")
        return
      }
      this.query();
      this.$refs.searchDialog.reset();
      this.searchParams = {};
    },
    confirm(data) {
      this.Entries.forEach((e,index) => {
        e.EntryRatio = Number(data[index].ExamRatio)
      })
      this.data.EntryLvSn = this.EntryLvSn;
      this.params.Entries = this.Entries;
    },
    confirm2(data) {
      this.isSearch = true;
      let obj = { AnalyseId: this.AnalyseId, ClassIds: data.ClassIds };
      if(data.type === 0) {
        obj.RecentTop5 = true;
      } else if(data.type === 1) {
        obj.Bad30 = true;
      } else if(data.type === 3) {
        obj.Good30 = true;
      }
      this.searchParams = obj;
      this.query();
      this.isSearch = false;
    },
    search() {
      if(!this.params.ThisExamId) {
        this.$message.error("请先选择当前考试");
        return
      }
      if(this.params.Entries.length==0) {
        this.$message.error("请先选择入口考试");
        return
      }
      this.$refs.searchDialog.open();
      this.$refs.searchDialog.setData(this.params.ThisExamId,this.TermId);
    },
    toDetails(row,name,teachername) {
      this.$refs.detailsDialog.open({ ...row, name, teachername });
    },
    reset() {
      this.AnalyseId = null;
      this.params.Entries = [];
      this.params.ThisExamId = null;
      this.data.ThisLvSn = "";
      this.data.EntryLvSn = "";
      this.TermId = null;
    },
    export() {
      if(!this.AnalyseId) {
        this.$message.warning("请先生成统计数据");
        return;
      }
      // this.api.export(this.AnalyseId)
      if(this.searchParams.AnalyseId) {
        this.api.newExport(this.searchParams);
      } else {
        this.api.newExport({ AnalyseId: this.AnalyseId });
      }
    },
  },
};
</script>
<style lang="scss" secopd>
.tname{
  font-size: 12px;
  margin-right: 0.5rem;
  vertical-align: top;
}
</style>